import { SolutionTag } from '@luminovo/api-contracts';
import { Flexbox, Tag, Tooltip } from '@luminovo/design-system';
import type { JSX } from 'react';

import { extractSolutionTagChips } from '../../extractors';
import { Solution } from '../../types';

const HighAttentionTags: readonly SolutionTag[] = [
    SolutionTag.PartAlternative,
    SolutionTag.PartAlternativeWarning,
    SolutionTag.NoLongerSelectable,
];

export function OfferChips({
    solution,
    fallbackSolutionTags = [],
}: {
    solution?: Pick<Solution, 'solutionTags'>;
    fallbackSolutionTags?: Solution['solutionTags'];
}): JSX.Element {
    const chips = extractSolutionTagChips(solution ?? { solutionTags: fallbackSolutionTags });

    return (
        <Flexbox
            gap={4}
            sx={{
                flexWrap: 'wrap',
            }}
        >
            {chips.map((c, idx) => {
                if (c.solutionTag === SolutionTag.ManualOffer) {
                    return null;
                }
                const tag = (
                    <Tag
                        color={c.color}
                        label={c.label}
                        attention={HighAttentionTags.includes(c.solutionTag) ? 'high' : 'low'}
                    />
                );
                if (!c.tooltip) {
                    return <span key={idx}>{tag}</span>;
                }
                return (
                    <Tooltip key={idx} title={c.tooltip}>
                        <span>{tag}</span>
                    </Tooltip>
                );
            })}
        </Flexbox>
    );
}
